<template>
    <div class="form-field form-field__input form-field__textarea" :class="[rootClasses]">
        <label class="form-field--title-label"
                v-if="label" :for="id"
                v-text="label">
        </label>
        <div class="form-field--input-container" :data-action-count="actionCount">
            <span class="form-field--floating-label"
                    v-if="hasFloatingLabel"
                    aria-hidden="true"
                    v-text="label">
            </span>
            <textarea class="form-field--input"
                    ref="input"
                    v-bind="inputBindings"
                    @input="updateValue($event.target.value)"
                    @focus="onFocus"
                    @blur="onBlur">
            </textarea>
            <div class="form-field--actions"></div>
        </div>
        <cmp-form-field-messages-partial :messages="messages"></cmp-form-field-messages-partial>
    </div>
</template>

<script>
    import formFieldAbstractMixin from 'vue/mixins/form/form-field-abstract';

    const TEXTAREA_BORDER_WIDTH = 0.5;
    const TEXTAREA_MAX_HEIGHT = 240;

    export default {
        mixins: [
            formFieldAbstractMixin,
        ],
        props: {
            type: String,
        },
        computed: {
            specificRootClasses() {
                return {
                    'form-field__has-focus': this.hasFocus,
                };
            },
            specificInputBindings() {
                const { placeholder } = this;
                return { placeholder };
            },
        },
        methods: {
            updateHeight() {
                const { input } = this.$refs;

                if (!input) {
                    return;
                }

                let contentHeight = input.scrollHeight + (TEXTAREA_BORDER_WIDTH * 2);

                if (contentHeight > TEXTAREA_MAX_HEIGHT) {
                    input.style.overflow = 'auto';
                    return;
                }

                input.style.height = 'auto';
                contentHeight = input.scrollHeight + (TEXTAREA_BORDER_WIDTH * 2);

                input.style.height = this.value ? `${ Math.min(TEXTAREA_MAX_HEIGHT, contentHeight) }px` : 'auto';
                input.style.overflow = contentHeight >= TEXTAREA_MAX_HEIGHT ? 'auto' : 'hidden';
            },
        },
        watch: {
            value: {
                handler() {
                    this.updateHeight();
                },
                immediate: true,
            },
        },
        mounted() {
            this.updateHeight();
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?3282082e